import { AlertTriangle } from "lucide-react"

// Amber content-moderation warning shown next to a candidate selfie that AWS Rekognition
// flagged (nudity / underwear / explicit). Rendered on the QA verification screen and the
// QA/client consumer report — never the candidate's own view, and never the TruCheck card
// (which hides the image outright). `labels` is the matched category list
// ([{ name, confidence }]); when present the category names are listed, otherwise a
// generic message is shown.
const ModerationWarning = ({ labels }) => {
    const names = (labels || []).map((l) => l?.name).filter(Boolean)

    return (
        <div className="flex items-start gap-1.5 w-full rounded-md border border-amber-300 bg-amber-50 px-2 py-1.5 text-amber-800">
            <AlertTriangle className="w-3.5 h-3.5 shrink-0 mt-0.5" />
            <div className="min-w-0">
                <p className="text-[11px] font-semibold leading-tight">Content warning</p>
                <p className="text-[10px] leading-tight text-amber-700 break-words">
                    {names.length ? names.join(", ") : "Possible inappropriate content"}
                </p>
            </div>
        </div>
    )
}

export default ModerationWarning
